import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProdTransportPackaging from "./Transport/Table";
import ProdWrappingTable from "./Wrapping/Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import transportWrapIcon from "../../../../../assets/new-product-detail-cats/sub-icons/product-transport-icon.svg";
import ProdSubBox from "../../components/SubcategoryBox/";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const ProductTransportWrappingContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("PRODUCT_PACKAGING")}
        isNormal={true}
        number={"11.2"}
        icon={transportWrapIcon}
      />
      <div>
        <ProdSubBox
          title={t("WRAPPING_PACKAGING_INFO")}
          desc={t("WRAPPING_PACKAGING_DESC")}
        />
        {shouldShowTable && (
          <TableLoadingWrapper
            tableId={`prod-transportwrapping-${productId}`}
            minLoadTime={3000}
            maxLoadTime={20000}
          >
            {" "}
            <ProdWrappingTable productId={productId} />
          </TableLoadingWrapper>
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
      <div>
        <ProdSubBox
          title={t("TRANSPORT_PACKAGING_INFO")}
          desc={t("TRANSPORT_PACKAGING_DESC")}
        />
        {shouldShowTable && (
          <TableLoadingWrapper
            tableId={`prod-transportpackaging-${productId}`}
            minLoadTime={3000}
            maxLoadTime={20000}
          >
            {" "}
            <ProdTransportPackaging productId={productId} />
          </TableLoadingWrapper>
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default ProductTransportWrappingContents;
